import type { CustomErrorRule } from '@/core/error/transport/types'
import { TmApiAuthentificationSessionExpiredError } from '@/core/error/transport/tmApiAuthentificationSessionExpiredError'

export const apiAuthenticationSessionExpiredErrorRule: CustomErrorRule = {
  subCodes: ['auth.two_factor_session_expired'],
  klass: TmApiAuthentificationSessionExpiredError,
}
